var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasDocumentAttachment(_vm.blockoutDay)
    ? _c(
        "ul",
        { staticClass: "attachment-list" },
        _vm._l(
          _vm.getDocumentUrls(_vm.blockoutDay.attachments),
          function (value, docUrlIndex) {
            return _c("li", { key: docUrlIndex }, [
              _c(
                "a",
                {
                  attrs: {
                    href: value.photoUrl,
                    download: "",
                    target: "_blank",
                  },
                },
                [
                  _c("md-icon", [
                    _vm._v("\n                picture_as_pdf\n            "),
                  ]),
                  _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(value.photoName) +
                        "\n            "
                    ),
                  ]),
                ],
                1
              ),
            ])
          }
        ),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }